import { CSSProperties, StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { CssSelectors } from '../../../styles/styles';

const { colors, spacing } = THEME;

export const defaultTagBackground: CSSProperties = {
	background: colors.pill.blue.background,
};
export const TagLeftAccessoryIconSize = 20;
export const TagHeight = 26;
export const TagFontSize = 12;
export const TagCssProps: CSSProperties = {
	minHeight: TagHeight,
	borderRadius: 18,
	boxSizing: 'border-box',
	color: colors.text.dark,
	fontSize: TagFontSize,
	letterSpacing: '0',
	padding: `${spacing.xs}px ${spacing.md}px`,
	...defaultTagBackground,
};

export const styleSheet = StyleSheet.create({
	alertIcon: {
		flexShrink: 0,
		height: 16,
		width: 16,
	},
	lockIcon: {
		flexShrink: 0,
		height: 11,
		width: 11,
		// Negative right margin compensates for the 10px marginLeft cascade on the
		// next content sibling, tightening the lock-to-text gap to ~4px.
		marginRight: -6,
	},
	container: {
		...TagCssProps,
		display: 'flex',
		alignItems: 'center',
		overflow: 'visible',
		position: 'relative',
		transition: 'all 300ms linear',
		':hover': {
			...CssSelectors.allChildren(
				{
					display: 'flex',
				},
				'.tag-remove-button'
			),
		},
	},
	containerSelected: {
		background: colors.primary.main,
		color: colors.primary.contrastText,
	},
	containerWithLeftAsset: {
		padding: '0px 15px 0px 6px',
	},
	content: {
		alignItems: 'center',
		display: 'flex',
		height: '100%',
		justifyContent: 'center',
		position: 'relative',
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
	removeButton: {
		alignItems: 'center',
		justifyContent: 'center',
		display: 'none',
		position: 'absolute',
		right: -2,
		top: -6,
	},
	selectedIndicator: {
		height: TagLeftAccessoryIconSize,
		width: TagLeftAccessoryIconSize,
	},
	tagAlertPopoverMessage: {
		color: colors.danger.main,
		fontSize: 12,
		letterSpacing: '0',
		padding: '5px 10px',
	},
	tagButton: {
		display: 'flex',
		alignItems: 'center',
		height: '100%',
		width: '100%',
	},
	tagValue: {
		maxWidth: 200,
	},
	automationPopover: {
		fontSize: 14,
		letterSpacing: '0',
		padding: '5px 10px',
	},
	automationPopoverMessage: {
		color: '#4a4a4a',
		padding: '5px 12px',
	},
	automationPopoverName: {
		color: colors.primary.main,
		padding: '5px 12px',
	},
	automationStartButton: {
		margin: '10px 10px',
		padding: '5px 12px',
	},
	automationXIcon: {
		cursor: 'pointer',
		marginRight: 5,
		textAlign: 'right',
	},
});
